export default __webpack_public_path__ + "static/media/rugDog.75aed869.svg";